import { DropdownContent, DropdownMenu, DropdownTrigger } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./file-sharing.scss";
import { formatBytes } from "./fileTreeUtils";
import { FileShareConsumptionDto, FileShareQuotaDto } from "domain/fileSharing";

import testIds from "testIds.json";

interface Props {
    quota: FileShareQuotaDto;
    consumption: FileShareConsumptionDto;
}

interface QuotaRow {
    labelKey: string;
    used: number;
    total: number;
}

export default function FileSharingQuotaIndicator({ quota, consumption }: Props): JSX.Element {
    const { t } = useTranslation();

    const rows: QuotaRow[] = [
        {
            labelKey: "FileSharing.quota.downloads",
            used: consumption.downloadedBytes,
            total: quota.downloadLimitBytes,
        },
        { labelKey: "FileSharing.quota.uploads", used: consumption.uploadedBytes, total: quota.uploadLimitBytes },
    ];

    return (
        <div className={style.quotaIndicatorWrapper}>
            <DropdownMenu position="bottom-end" closeOnSelection={false}>
                <DropdownTrigger>
                    <button
                        className={style.diskQuotaTrigger}
                        data-testid={testIds.workArea.fileSharing.quotaIndicatorMenu.button}
                    >
                        {t("FileSharing.diskQuota", {
                            used: formatBytes(consumption.usedDiskBytes),
                            total: formatBytes(quota.diskQuotaBytes),
                        })}
                        {" ▾"}
                    </button>
                </DropdownTrigger>
                <DropdownContent
                    className={style.diskQuotaPanel}
                    testId={testIds.workArea.fileSharing.quotaIndicatorMenu.content}
                >
                    {rows.map((row) => (
                        <div key={row.labelKey} className={style.diskQuotaPanelRow}>
                            <span className={style.diskQuotaPanelLabel}>{t(row.labelKey)}</span>
                            <div>
                                <div className={style.diskQuotaPanelValue}>
                                    {formatBytes(row.used)} / {formatBytes(row.total)}
                                </div>
                                <div className={style.diskQuotaPanelSubText}>{t("FileSharing.quota.monthly")}</div>
                            </div>
                        </div>
                    ))}
                </DropdownContent>
            </DropdownMenu>
        </div>
    );
}
